import React, { memo } from 'react';
import { createUseStyle } from '@redlink/assets/styles';
import { LoadingContainer } from '@redlink/components/atoms';
import { PreviewLinksList } from '@redlink/components/muscles';
import { PreviewUserInfo } from '@redlink/components/molecules';
import { useQuery, getPagePreviewLinkQuery } from '@redlink/services';

export const PreviewLinkPage = memo(({ pageName }) => {
  const { styles } = useStyle();

  const {
    loading,
    data: { LinksPreview },
  } = useQuery(getPagePreviewLinkQuery, { variables: { pageName } });

  return (
    <LoadingContainer
      hasOverlay={false}
      isBusy={loading}
      style={styles.container}
    >
      <PreviewUserInfo {...{ pageName }} style={styles.userInfoContainer} />
      <PreviewLinksList data={LinksPreview} />
    </LoadingContainer>
  );
});

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {
    flex: 1,
    backgroundColor: colors.background,
  },
  userInfoContainer: {
    margin: 24,
  },
}));
